import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import FilterItemValues from 'components/FilterItemGroup/components/FilterItemValues/FilterItemValues';
import styled from 'styled-components/macro';
import { getSuggestion } from 'state/application/actions';
import { get } from 'lodash';
import { variables } from 'theme/variables';

const { custom_red: customRed } = variables;

const CompanyLookupWrapper = styled.div`
  width: 100%;
  display: flex;
`;

function CompanyLookup({
  clientId,
  defaultLookup,
  searchKey,
  colorOverride,
  validation,
  itemSelection,
  itemSelectionMini,
  size,
  medium,
  semibold,
  itemsSmall,
  value,
  selectedValue,
  onBlur,
  defaultValue,
  setSelectedValue,
  title,
  clearable,
  required,
}) {
  const [searchValues, setSearchValues] = useState([]);
  const [defaultArray, setDefaultArray] = useState([]);
  const [originalResultsReturned, setOriginalResultsReturned] = useState(null);
  async function searchSuggestion(search, inputValue) {
    const { key, setter } = search;
    const aa = await getSuggestion(key, inputValue, {
      valueKey: search.valueKey,
      labelKey: search.labelKey,
      clientId: search.clientId,
      includeContacts: search.includeContacts,
    });
    if (aa && !aa.error) {
      setter((previousValue) => {
        if (previousValue.length === 0 && aa.length === 0) {
          return previousValue;
        }
        return aa;
      });
    } else {
      setter((previousValue) => {
        if (previousValue.length > 0) {
          return [];
        }
        return previousValue;
      });
    }
    return aa;
  }
  const search = useMemo(
    () => ({
      company: {
        key: 'company',
        setter: setSearchValues,
      },
      user: {
        key: 'user',
        setter: setSearchValues,
        clientId,
        includeContacts: false,
        labelKey: 'full_name',
      },
    }),
    [clientId]
  );

  useEffect(() => {
    async function getDefaultSuggestions() {
      const v = await searchSuggestion(search[searchKey], undefined);
      if (v && !v.error) {
        setDefaultArray(v);
      }
      setOriginalResultsReturned(true);
    }
    if (defaultLookup) {
      getDefaultSuggestions();
    }
  }, [defaultLookup, search, searchKey]);

  if (defaultLookup && !originalResultsReturned) {
    return <div />;
  }

  return (
    <CompanyLookupWrapper>
      {required ? <span style={{ color: customRed }}> * </span> : null}
      <FilterItemValues
        popperModifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
        persistCasing
        required
        colorOverride={colorOverride}
        minDropdownWidth="320px"
        error={!!validation}
        validation={validation}
        itemSelection={itemSelection === false ? false : !itemSelectionMini}
        size={size}
        medium={medium}
        semibold={semibold}
        itemsSmall={itemsSmall}
        search={(inputValue) => searchSuggestion(search[searchKey], inputValue)}
        optionEllipsis
        defaultOptions={defaultArray}
        optionValues={searchValues || defaultArray}
        selectedValue={value || selectedValue}
        onBlur={onBlur}
        ignoreFilter
        defaultValue={defaultValue}
        setSelectedValue={setSelectedValue}
        clearable={clearable !== false}
        title={
          title ||
          (get(search[searchKey], 'key') === 'user' ? 'User' : 'Company')
        }
      />
    </CompanyLookupWrapper>
  );
}

CompanyLookup.propTypes = {
  clientId: PropTypes.number,
  defaultLookup: PropTypes.bool,
  searchKey: PropTypes.string,
  colorOverride: PropTypes.string,
  validation: PropTypes.string,
  itemSelection: PropTypes.bool,
  itemSelectionMini: PropTypes.bool,
  size: PropTypes.number,
  medium: PropTypes.bool,
  semibold: PropTypes.bool,
  itemsSmall: PropTypes.bool,
  value: PropTypes.string,
  selectedValue: PropTypes.string,
  onBlur: PropTypes.func,
  defaultValue: PropTypes.string,
  setSelectedValue: PropTypes.func,
  title: PropTypes.string,
  clearable: PropTypes.bool,
  required: PropTypes.bool,
};

export default CompanyLookup;
